import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDLpqLn2B21qUE2F1nehBtVDHt6IUX14yA",
  authDomain: "transfer-e077b.firebaseapp.com",
  databaseURL: "https://transfer-e077b-default-rtdb.firebaseio.com",
  projectId: "transfer-e077b",
  storageBucket: "transfer-e077b.appspot.com",
  messagingSenderId: "235203544427",
  appId: "1:235203544427:web:39bc494997088e556a782e",
  measurementId: "G-R2W6SHMB5S"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

console.log("✅ Firebase initialized for NEW PROJECT: transfer-e077b");